import axios from "axios";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { EXCHNAGE_URL } from "../../../Url/Url";
import { FaTrash, FaUndo } from "react-icons/fa";
import { toast } from "react-toastify";

const TableContainer = styled.div`
  overflow-x: auto;
  padding: 1rem;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.thead`
  background-color: #f0f0f0;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #ddd;
  background-color: ${(props) => (props.isBlocked ? "#ffcece" : "#cbffcb")}; /* Light red for blocked, light green for unblocked */
`;

const TableCell = styled.td`
  padding: 8px;
  text-align: left;
  color: black;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
  color: #333;
  &:hover {
    color: red;
  }
`;

const AllAdmin = () => {
  const [admin, setAdmin] = useState([]);

  const token = localStorage.getItem("token");

  const getAllData = async () => {
    try {
      const response = await axios.get(`${EXCHNAGE_URL}/getalladmin`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setAdmin(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const toggleBlocked = async (adminId, currentStatus) => {
    const newBlockStatus = currentStatus === 0 ? 1 : 0;

    try {
     const response = await axios.post(`${EXCHNAGE_URL}/blockadmin?adminId=${adminId}&block=${newBlockStatus}`, {
        headers: {
        //   Authorization: `Bearer ${token}`,
        },
      });

      setAdmin((prevAdmins) =>
        prevAdmins.map((user) =>
          user.adminId === adminId ? { ...user, is_blocked: newBlockStatus } : user
        )
      );
      if(response.status === 200){
      toast.success("Admin List Updated Successfully")
      }
    } catch (error) {
      console.error("Error toggling block status:", error);
    }
  };

  useEffect(() => {
    getAllData();
  }, []);

  return (
    <TableContainer>
      <StyledTable>
        <TableHeader>
          <tr>
            <TableCell as="th">Name</TableCell>
            <TableCell as="th">Email</TableCell>
            <TableCell as="th">Mobile Number</TableCell>
            <TableCell as="th">Total Events</TableCell>
            <TableCell as="th">Action</TableCell>
          </tr>
        </TableHeader>
        <tbody>
          {admin &&
            admin.map((admin) => (
              <TableRow key={admin.adminId} isBlocked={admin.is_blocked }>
                <TableCell>{`${admin.first_name} ${admin.last_name}`}</TableCell>
                <TableCell>{admin.email}</TableCell>
                <TableCell>{admin.mobile_number}</TableCell>
                <TableCell>{admin.total_events}</TableCell>
                <TableCell>
                  <ActionButton onClick={() => toggleBlocked(admin.adminId, admin.is_blocked)}>
                    {admin.is_blocked === 0 ? <FaTrash /> : <FaUndo />}
                  </ActionButton>
                </TableCell>
              </TableRow>
            ))}
        </tbody>
      </StyledTable>
    </TableContainer>
  );
};

export default AllAdmin;
